<template>
  <div class="chat-room">
    <!-- 聊天内容 -->
    <!-- <div class="chat-loading" v-show="!isChatLoaded">加载中...</div> -->
    <!--    <el-button style="position: fixed;top: 10px;right: 50px;z-index: 9999;" @click="testJoin1">入场动画测试</el-button>-->
    <div
      class="chat_content"
      ref="chatMess"
      @scroll="onscroll"
      v-show="!isChatLoaded"
    >
      <!-- 系统提示 -->
      <!-- <div class="system_tip" ref="systemTip" v-show="isShowText">
        <p v-if="systemTipText.indexOf('系统提示：') === 0">
          <span style="color: #33cc00">系统提示：</span>
          <span>{{ systemTipText.substring(5) }}</span>
        </p>
        <p v-else>
          {{ systemTipText }}
        </p>
      </div> -->
      <div
        class="chat_item"
        v-for="(item, index) in [{ ...firstWellMsg }, ...messageList]"
        :key="index"
      >
        <div v-if="item && item.type === 'first_wel'" class="chat">
          <span class="right" v-html="formatMsg(item.content)" />
        </div>
        <!-- 用户消息 -->
        <div
          class="chat"
          :style="[
            fontColorToBackgroundColor(item.textColor),
            addPaddingRight(item.isColorful),
          ]"
          v-if="item.type === 'say'"
        >
          <div
            class="colorful-bar"
            v-show="item.isColorful"
            :style="{ backgroundColor: item.textColor }"
          ></div>
          <span class="level" :style="fontColorToLinearGradient(item.textColor)"
            >LV{{ item.level }}</span
          >
          <img
            class="noble"
            v-if="item.vip > 0"
            :src="nobleBadge[item.vip - 1]"
            alt=""
          />
          <!-- <img
            class="room-anchor"
            v-if="item.role == 2"
            src="./img/anchor.png"
            alt=""
          /> -->
          <div class="anchor_box" v-if="item.role == 2">
            <div class="anchor">
              <img :src="require('@/assets/live/anchor.png')" alt="" />
              <span>{{ $t("common.anchor") }}</span>
            </div>
          </div>
          <!-- <img
            class="room-manager"
            v-if="item.role == 3"
            src="./img/room-manager.png"
            alt=""
          /> -->
          <div class="manager_box" v-if="item.role == 3">
            <div class="manager">
              <img :src="require('@/assets/live/help.png')" alt="" />
              <span>{{ $t("common.liveManage") }}</span>
            </div>
          </div>
          <div class="pendant" v-if="item.props && item.props.pendant">
            <img
              v-for="(i, index) in item.props.pendant"
              :key="index"
              :src="i.icon"
              alt=""
            />
          </div>
          <span class="left" v-if="item.user_id === userInfo.id">
            {{ item.from_client_name }}：
          </span>
          <span class="left" v-else @click="popupBlockUserStep1(item)">
            {{ item.from_client_name }}：
          </span>
          <span
            v-if="item.user_id === userInfo.id"
            class="right"
            :style="{ color: item.textColor }"
            v-html="formatMsg(item.content)"
          />
          <span
            v-else
            @click="popupDeleteMsg(item)"
            class="right"
            :style="{ color: item.textColor }"
            v-html="formatMsg(item.content)"
          />
          <i
            v-show="errorMessageIds.indexOf(item.messageId) > -1"
            @click="showErrorMsg"
            class="el-icon-warning"
            style="font-size: 15px; color: red; cursor: pointer"
          ></i>
          <img
            class="colorful-char"
            v-show="item.textColor === '#113BD0'"
            src="./img/colorful-char1.png"
            alt=""
          />
          <img
            class="colorful-char"
            v-show="item.textColor === '#E41EB1'"
            src="./img/colorful-char2.png"
            alt=""
          />
          <img
            class="colorful-char"
            v-show="item.textColor === '#FF6B00' && item.isColorful"
            src="./img/colorful-char3.png"
            alt=""
          />
        </div>
        <!-- 关注主播 -->
        <div class="chat" v-if="item.type === 'attentAnchor'">
          <span class="left"> {{ item.from_client_name }} </span>
          <span class="right">{{ $t("live.followText") }}</span>
        </div>
        <!-- 欢迎来到本直播间 -->
        <div class="chat" v-if="item.type === 'login'">
          <span class="level" :style="levelToLinearGradient(item.level)"
            >LV{{ item.level }}</span
          >
          <img
            class="noble"
            v-if="item.vip_level > 0"
            :src="nobleBadge[item.vip_level - 1]"
            alt=""
          />
          <!-- <img
            class="room-anchor"
            v-if="item.role == 2"
            src="./img/anchor.png"
            alt=""
          /> -->
          <div class="anchor_box" v-if="item.role == 2">
            <div class="anchor">
              <img :src="require('@/assets/live/anchor.png')" alt="" />
              <span>{{ $t("common.anchor") }}</span>
            </div>
          </div>
          <!-- <img
            class="room-manager"
            v-if="item.role == 3"
            src="./img/room-manager.png"
            alt=""
          /> -->
          <div class="manager_box" v-if="item.role == 3">
            <div class="manager">
              <img :src="require('@/assets/live/help.png')" alt="" />
              <span>{{ $t("common.liveManage") }}</span>
            </div>
          </div>
          <span class="left" @click="popupBlockUserStep1(item)">
            {{ item.client_name }}：</span
          >
          <span class="right" :style="levelToFontColor(item.level)">{{
            $t("live.welcome")
          }}</span>
        </div>
        <!-- 超管禁言消息 -->
        <div class="chat" v-if="item.type === 'bannedUser'">
          <!-- <span class="chao">超</span> -->
          <span class="left" @click="popupBlockUserStep1(item)">
            {{ item.client_name + ":" }}
          </span>
          <span class="disabled" style="color: red">{{
            $t(`chat.ban${item.r}`, {
              num: Math.floor(Number(item.t) / 60),
            })
          }}</span>
        </div>
        <!-- 超管解除禁言消息 -->
        <div class="chat" v-if="item.type === 'unbannedUser'">
          <!-- <span class="chao">超</span> -->
          <span class="left">{{ item.client_name + ":" }}</span>
          <span class="disabled" style="color: #26d99d">{{
            `[ ${item.client_name} ] ${$t("live.unbannedUser")}`
          }}</span>
        </div>
        <!-- 礼物消息 -->
        <div class="chat" v-if="item.type === 'gift'">
          <span class="level" :style="levelToLinearGradient(item.level)"
            >LV{{ item.level }}</span
          >
          <img v-if="item.role == 2" src="./img/anchor.png" alt="" />
          <img v-if="item.role == 3" src="./img/room-manager.png" alt="" />
          <!-- <img src="./img/diamond.png" alt="" /> -->
          <!-- <span class="me" v-if="item.sender === userInfo.id">[我]</span> -->
          <span class="left" @click="popupBlockUserStep1(item)">
            {{ item.from_client_name }}：
          </span>
          <span class="right">{{ $t("common.giftSend") }}</span>
          <img class="gift-icon" :src="item.icon" alt="" />
          <span class="right">{{ item.count }}</span>
          <span class="right" style="color: #999999; margin-left: 0.05rem">{{
            item.hit + $t("gift.hit")
          }}</span>
        </div>
      </div>
    </div>
    <div class="to_bottom_btn" @click="toBottom" v-if="showMoreMsg">
      {{ $t("chat.thereIsNew") }}
    </div>
    <div class="welcome-border" v-show="welcomeMsg.length > 0"></div>
    <div
      class="welcome-list"
      ref="welcomeScrollTo"
      v-show="welcomeMsg.length > 0"
      :style="{ height: welcomeMsg.length > 1 ? '0.64rem' : '0.32rem' }"
    >
      <div class="welcome" v-for="(item, index) in welcomeMsg" :key="index">
        <div
          class="welcome-level"
          v-show="item.client_name.indexOf('匿名') == -1"
        >
          {{ "LV" + item.level }}
        </div>
        <div class="welcome-name">{{ item.client_name }}:</div>
        <div
          class="welcome-msg"
          :style="{
            color:
              item.client_name.indexOf('匿名') == -1 ? '#3C9CFE' : '#999999',
          }"
        >
          {{ $t("live.welcome") }}
        </div>
      </div>
      <!-- <div ref="welcomeScrollTo" style="height: 1px"></div> -->
    </div>

    <div v-show="isColorTextShow" style="height: 0.4rem"></div>

    <!-- 删除消息 -->
    <div class="delete-msg" v-show="isDeleteMsg">
      <div class="delete-msg-header">
        <div>{{ $t("chat.manage") }}</div>
        <img @click="isDeleteMsg = false" src="./img/close.png" alt="" />
      </div>
      <div class="delete-msg-content">
        <div class="content">
          <span>{{ userMessage.from_client_name }} :</span>
          {{ userMessage.content }}
        </div>
        <div class="delete_btn" @click="deleteMessage()">
          <img :src="require('@/assets/live/delete.png')" alt="" />
          <span>{{ $t("live.delete") }}</span>
        </div>
      </div>
    </div>
    <!-- 禁言用户弹窗 -->
    <div class="block-user-step1" v-if="isBlockUserStep1">
      <div class="header">
        <img
          @click="isBlockUserStep1 = false"
          src="./img/close-grey.png"
          alt=""
        />
      </div>
      <div class="logo">
        <img class="img1" :src="bannedUser.target_user_avatar" alt="" />
        <img class="img2" :src="bannedUserNoble" alt="" />
      </div>
      <div class="name">
        <div>{{ bannedUser.target_user_name }}</div>
        <img :src="bannedUserLevel" alt="" />
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('chat.blockTime')" prop="time">
          <el-select
            v-model="ruleForm.time"
            :placeholder="$t('chat.blockTimePlace')"
            @change="changeBannedTime"
          >
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="(item, index) in bannedTimeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('chat.blockReason')" prop="reason">
          <el-select
            v-model="ruleForm.reason"
            :placeholder="$t('chat.blockReasonPlace')"
            @change="changeBannedReason"
          >
            <el-option
              :label="item.name"
              :value="{ value: item.value, label: item.name }"
              v-for="(item, index) in bannedReasonList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-show="!isBannedBtnShow" class="btn">{{ $t("chat.block") }}</div>
      <div
        @click="blockUserConfirm()"
        v-show="isBannedBtnShow"
        class="btn btn-active"
      >
        {{ $t("chat.block") }}
      </div>
    </div>
    <!-- <div class="block-user-step2" v-show="isBlockUserStep2">
      <div class="header">
        <div>禁言时长</div>
        <img @click="isBlockUserStep2 = false" src="./img/close.png" alt="" />
      </div>
      <div @click="changeDuration(index, item.time)" class="content" v-for="(item, index) in blockDuration" :key="index">
        <img :src="durationSelect == index ? require('./img/select_on.png') : require('./img/select_off.png')" alt="" />
        <div>{{ item.duration }}</div>
      </div>
      <div class="bottom">
        <div class="btn btn1" @click="isBlockUserStep2 = false">取消</div>
        <div class="btn" @click="blockUserConfirm()">确认</div>
      </div>
    </div> -->
    <!-- 解除禁言弹窗 -->
    <div class="block-user-step1 unblock-user" v-show="isUnblockUser">
      <div class="header">
        <img @click="isUnblockUser = false" src="./img/close-grey.png" alt="" />
      </div>
      <div class="logo">
        <img class="img1" :src="bannedUser.target_user_avatar" alt="" />
        <img class="img2" :src="bannedUserNoble" alt="" />
      </div>
      <div class="name">
        <div>{{ bannedUser.target_user_name }}</div>
        <img :src="bannedUserLevel" alt="" />
      </div>
      <div @click="unblockUser()" class="btn" style="background: #db6372">
        {{ $t("live.unbannedUser") }}
      </div>
    </div>
    <!-- 连击礼物展示 -->
    <div class="continuous-gift" v-if="isContinuousGift">
      <div class="gift-list" v-for="item in continuousGift" :key="item.giftid">
        <div class="a text-overflow">
          {{ item.from_client_name }}
        </div>
        <div class="b">{{ $t("common.giftSend") }}</div>
        <div class="c">
          <img :src="item.icon" alt="" />
        </div>
        <div class="d">
          <img
            v-for="(i, index) in transNumberToPicture(item.count)"
            :key="index"
            :src="require('../../assets/img/picture-number/num2/' + i)"
          />
        </div>
        <div class="e">
          <img src="@/assets/img/picture-number/num1/x.png" alt="" />
        </div>
        <div class="f">
          <img
            v-for="(i, index) in transNumberToPicture(item.hit)"
            :key="index"
            :src="require('../../assets/img/picture-number/num1/' + i)"
          />
        </div>
      </div>
    </div>
    <!-- 赠送礼物展示 -->
    <div class="gift_content" v-show="isGiftPlaying">
      <!-- <img
        class="gift_conten_img"
        :src="giftInfo && giftInfo.animation ? giftInfo.animation : ''"
        alt
        v-show="!giftInfo.animation.includes('.svga')"
      />
      <div v-show="giftInfo.animation.includes('.svga')" id="svg_play2" style="width: 330px; height: 440px"></div> -->
      <!-- <div id="svg_play2" style="width: 330px; height: 440px"></div> -->
      <div id="svg_play2" style="width: 3.4rem; height: 4.4rem"></div>
      <!-- <canvas id="svg_play2" style="width: 100%; height: 100%"></canvas> -->
    </div>

    <div class="message_bottom">
      <div class="icon_btn">
        <emoji-picker @emoji="insert">
          <div
            slot="emoji-invoker"
            slot-scope="{ events: { click: clickEvent } }"
            @click.stop="clickEvent"
          >
            <img
              class="icon-img"
              src="./img/emoji.png"
              title="表情"
              @click="() => (isShowPlug = false)"
            />
          </div>
          <div
            class="emoji"
            slot="emoji-picker"
            slot-scope="{ emojis, insert }"
          >
            <div class="emoji-cats">
              <div
                class="emoji-cat"
                :class="emojiCategory == index ? 'emoji-active' : ''"
                @click="changeEmojiCategory(index)"
                v-for="(item, index) in emojiCates"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div
              v-for="(emojiGroup, category, index) in emojis"
              :key="category"
            >
              <div class="emoji-item" v-if="emojiCategory == index">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                  >{{ emoji }}</span
                >
              </div>
            </div>
          </div>
        </emoji-picker>
        <img
          class="icon-img"
          v-show="!isColorTextShow"
          @click.stop="showColorText()"
          src="./img/colorText.png"
          alt
        />
        <img
          class="icon-img"
          v-show="isColorTextShow"
          @click.stop="showColorText()"
          src="./img/colorText-select.png"
          alt
        />
        <div class="color-text-popup" v-show="isColorTextShow" @click.stop>
          <div class="color-text">
            <div
              class="lv_item"
              v-for="(item, index) in colorText"
              @click="changeTextColor(index, item.lv)"
              :style="item.bg"
            >
              <span class="text">{{
                index === 0 ? $t("live.fontDefault") : `LV${item.lv}`
              }}</span>
              <img
                :src="level < item.lv ? require('@/assets/live/lock.svg') : ''"
                alt=""
              />
              <img
                v-if="activeTextColor === index"
                :src="require('@/assets/live/select.svg')"
                alt=""
              />
            </div>
            <!-- <img
              v-for="(item, index) in colorText"
              :key="index"
              :class="level < item.lv ? 'not-click' : ''"
              @click="changeTextColor(index, item.lv)"
              :src="
                activeTextColor == index
                  ? item.b
                  : level >= item.lv
                  ? item.a
                  : item.c
              "
              alt=""
            /> -->
          </div>
          <div class="bar-bottom"></div>
        </div>

        <img
          class="icon-img"
          v-show="!isSpeakerShow"
          @click.stop="showSpeaker()"
          src="./img/speaker.png"
          alt
        />
        <img
          class="icon-img"
          v-show="isSpeakerShow"
          @click.stop="showSpeaker()"
          src="./img/speaker-select.png"
          alt
        />

        <img
          class="icon-img"
          v-show="!isShowShield"
          src="./img/block_danmu.png"
          @click.stop="showShield()"
          alt
        />
        <img
          class="icon-img"
          v-show="isShowShield"
          src="./img/block_danmu-select.png"
          @click.stop="showShield()"
          alt
        />
        <div class="chat-shield" v-show="isShowShield" @click.stop>
          <div
            :class="['shield-item', isGiftBlocked ? 'shield-item-active' : '']"
            @click="blockGiftAnimation()"
          >
            <div class="select_box" :class="isGiftBlocked ? 'active' : ''">
              <img
                v-if="isGiftBlocked"
                :src="require('@/assets/live/select.svg')"
                alt=""
              />
            </div>
            <!-- <img v-show="!isGiftBlocked" src="./img/checkbox.png" alt="" />
            <img
              v-show="isGiftBlocked"
              src="./img/checkbox-select.png"
              alt=""
            /> -->
            <div>{{ $t("chat.blockAnimate1") }}</div>
          </div>
          <div class="shield-bar"></div>
          <div
            :class="['shield-item', isNobleBlocked ? 'shield-item-active' : '']"
            @click="blockNobleAnimation()"
          >
            <!-- <img v-show="!isNobleBlocked" src="./img/checkbox.png" alt="" />
            <img
              v-show="isNobleBlocked"
              src="./img/checkbox-select.png"
              alt=""
            /> -->
            <div class="select_box" :class="isNobleBlocked ? 'active' : ''">
              <img
                v-if="isNobleBlocked"
                :src="require('@/assets/live/select.svg')"
                alt=""
              />
            </div>
            <div>{{ $t("chat.blockAnimate2") }}</div>
          </div>
        </div>
        <div class="colorfull">
          <!-- <div class="icon-bar"></div>
          <img
            @click.stop="showColorful()"
            class=""
            src="./img/colorful-danmu.png"
          /> -->
          <div class="out">
            <div class="text_box" @click.stop="showColorful()">
              {{ $t("live.colorFul") }}
            </div>
          </div>
        </div>
        <img
          v-show="isColorfulShow"
          class="colorfull-arrow"
          src="./img/colorful-arrow.png"
          alt=""
        />
        <div v-show="isColorfulShow" class="colorfull-popup">
          <div
            class="colorfull-popup-list"
            @click="changeColorful(index, item.number)"
            v-for="(item, index) in colorfulText"
            :key="index"
          >
            <img :src="item.a" alt="" />
            <div
              class="mid"
              :class="index == 1 ? 'mid2' : index == 2 ? 'mid3' : ''"
            >
              {{ item.text }}x{{ item.number || 0 }}
            </div>
            <img :src="item.b" alt="" />
          </div>
        </div>
      </div>
      <div class="sent_content">
        <div class="input_content">
          <div class="not_login" v-if="!userInfo.id">
            <span class="l_text1" @click="showLogin">{{
              $t("chat.loginText")
            }}</span
            >&nbsp;
            <span class="l_text2">{{ $t("chat.send") }}</span>
          </div>
          <div class="write-color" v-if="userInfo.id && isColorTextShow">
            <img
              v-for="(item, index) in colorWrite"
              :key="index"
              v-show="activeTextColor == index"
              :src="item"
              alt=""
            />
            <div class="bar"></div>
          </div>
          <div class="write-color" v-if="userInfo.id && isColorfulSelectShow">
            <!-- <img class="colorful-text" src="./img/colorful-text.png" alt="" /> -->
            <div class="out">
              <div class="text_box" @click.stop="showColorful()">
                {{ $t("live.colorFul") }}
              </div>
            </div>

            <div class="bar"></div>
          </div>
          <div class="write-color" v-if="userInfo.id && isSpeakerShow">
            <img src="./img/speaker-select.png" alt="" />
            <div class="bar"></div>
          </div>
          <textarea
            ref="sendMsgInput"
            :style="{
              color: isColorfulSelectShow
                ? colorfulTextColor[colorfulSelected]
                : colorInput[activeTextColor],
            }"
            type="text"
            v-if="userInfo.id"
            class="login_input"
            required="required"
            @input="formatMessage"
            v-model="messageContent"
            rows="1"
            @keyup.enter="
              isColorfulSelectShow || isSpeakerShow ? sendProps() : sendMsg()
            "
            @keyup.delete="toGeneralFont"
          />
        </div>
        <div
          class="input_send"
          v-if="isColorfulSelectShow || isSpeakerShow"
          @click="sendProps"
        >
          {{ $t("chat.sendText") }}
        </div>
        <div class="input_send" v-else @click="sendMsg">
          {{ $t("chat.sendText") }}
        </div>
        <!-- <div class="input_send" @click="unblockUser">发送</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex";
import { transNumberToPicture } from "../../util/picNumber";
import playSvgaMixin from "@/mixins/playSvgamixin";
import TIM from "tim-js-sdk";
import { tim, timJoinGroup } from "@/util/tim";
import event from "@/event";
import { EmojiPicker } from "vue-emoji-picker";

import {
  fontColorToLinearGradient,
  fontColorToBackgroundColor,
  levelToLinearGradient,
  levelToFontColor,
} from "@/util/fontColorToLinearGradient";

export default {
  name: "chatRoom",
  mixins: [playSvgaMixin],
  components: { EmojiPicker },
  props: {
    liveDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    anchor: {
      type: Object,
      default() {
        return {};
      },
    },
    roomId: {
      type: Number,
    },
  },
  watch: {
    // roomId(newVal, oldVal) {
    //   this.initTim();
    // },
    // appConfig() {
    //   this.initTim();
    // },
    async isTimReady(newValue) {
      if (newValue) {
        this.systemTipText = await timJoinGroup(
          this.room,
          this.liveDetail.anchor_name
        );
      }
      // this.initJoinRoom();
      console.log(newValue, "isTimReady");
    },
    props() {
      this.colorfulText[0].number = this.props.colorful1;
      this.colorfulText[1].number = this.props.colorful2;
      this.colorfulText[2].number = this.props.colorful3;

      //先使用第一条炫彩
      // if (this.props.colorful1 > 0) {
      //   this.isColorfulSelectShow = true;
      //   this.isColorTextShow = false;
      // }
    },
    messageList(newVal) {
      // console.log(newVal, newVal[newVal.length - 1], "newVal");
      let lastArray = newVal[newVal.length - 1] || {};
      // this.$emit("sendDanmu", newVal);
      if (!this.isBottom) {
        this.showMoreMsg = true;
      }

      if (
        lastArray.type === "login" &&
        lastArray.vip_level >= 1 &&
        !this.isNobleBlocked
      ) {
        this.addAdmissionAnimate({ ...lastArray });
      }

      if (lastArray.user_id === this.userInfo.id || this.isBottom === true) {
        this.toBottom();
      }
    },
    welcomeMsg() {
      this.$nextTick(() => {
        this.$refs["welcomeScrollTo"].scrollTop =
          this.$refs["welcomeScrollTo"].scrollHeight;
      });
    },
    giftAnimation(newVal) {
      console.log(newVal, "newVal");
      if (
        newVal.type === "gift" &&
        /\.svga$/.test(newVal.animation) &&
        newVal.animat_type > 0 &&
        !this.isGiftBlocked
      ) {
        for (let i = 0; i < newVal.count; i++) {
          this.addAnimation(newVal);
        }
        this.playSvgaAnimation(); // 播放礼物动画
      }
      this.$emit("getRewardRange", 0);
    },
  },
  computed: {
    ...mapState([
      "defaultAvatar",
      "categories",
      "userInfo",
      "liveBarrage",
      "showBarrage",
      "appConfig",
      "gifts",
      "props",
      "chatConfig",
      "isTimReady",
      "welcomeMsg",
      "messageList",
      "colorfulTextColor",
      "loginRepData",
      "isContinuousGift",
      "continuousGift",
      "giftAnimation",
      "disabledSendMsg",
    ]),
  },
  data() {
    return {
      isChatLoaded: false,
      checked: false,
      shieldChecked: false,
      emojiCategory: 0,
      emojiCates: [
        this.$t("emoji.recently"),
        this.$t("emoji.smile"),
        this.$t("emoji.anima"),
        this.$t("emojiPicker.project"),
      ],
      websock: null,
      isAdmin: false,
      isShowText: true,
      ind: 0, // 禁言弹窗位置
      isShowDisable: false, // 禁言弹窗
      isShowAble: false, // 解除禁言弹窗
      chatBox: "",
      showMoreMsg: false,
      popMsg: {},
      systemTipText: "",
      // messageList: [],
      // continuousGift: [],
      giftInfo: {
        animation: "",
      },
      messageContent: "",
      // isshowGift: false,
      isShowPlug: false,
      isloadPlug: false,
      isClassicShow: false,
      isShowShield: false,
      isColorTextShow: true,
      // shieldItem: [{ title: "屏蔽礼物特效" }, { title: "屏蔽贵族特效" }],
      shieldItem: [{ title: this.$t("chat.blockAnimate1") }],
      isGiftBlocked: false,
      isNobleBlocked: false,
      plugTab: 0,
      plugList: [],
      bgColorList: [],
      fontColorList: [],
      wsGateway: "",
      wsToken: "",
      times: 0,
      isDeleteMsg: false,
      userMessage: {},
      isBlockUserStep1: false,
      isBlockUserStep2: false,
      isDurationSelect: true,
      blockDuration: [
        { duration: this.$t("block.1day"), time: 1 },
        { duration: this.$t("block.3days"), time: 3 },
        { duration: this.$t("block.7days"), time: 7 },
        { duration: this.$t("block.forever"), time: 0 },
      ],
      durationSelect: 0,
      bannedTime: 0,
      bannedReason: {},
      isUnblockUser: false,
      bannedUser: {},
      bannedUserLevel: require("@/assets/img/level-user/1.png"),
      bannedUserNoble: require("@/assets/img/noble/0.png"),
      role: 1,
      // player: null,
      // parser: null,
      // db: null,
      room: 0,
      tim: null,
      // loginRepUser: {},
      errorMessageIds: [],
      errorMsg: "",
      deleteMsgId: 0,
      colorText: [
        {
          bg: "background: linear-gradient(90deg, #0f0f0f 0%, #5c5a5a 100%)",
          lv: 0,
        },
        {
          bg: "background: linear-gradient(90deg, #3dc0e8 0%, #bbdde8 100%)",
          lv: 2,
        },
        {
          bg: "background: linear-gradient(90deg, #5346e6 0%, #a19ae9 100%)",
          lv: 8,
        },
        {
          bg: "background: linear-gradient(90deg, #FF859D 0%, #f2b4c1 100%)",
          lv: 16,
        },
        {
          bg: "background: linear-gradient(90deg, #FFAC04 0%, #eecb84 100%)",
          lv: 21,
        },
      ],
      colorWrite: [
        require("./img/write.png"),
        require("./img/write-lv2.png"),
        require("./img/write-lv8.png"),
        require("./img/write-lv16.png"),
        require("./img/write-lv21.png"),
      ],
      colorInput: ["#333333", "#0085FF", "#6E61FF", "#FF2652", "#FF6B00"],
      activeTextColor: 0,
      level: 8,
      isColorfulShow: false,
      isColorfulSelectShow: false,
      colorfulText: [
        {
          a: require("./img/colorful1-start.png"),
          b: require("./img/colorful1-end.png"),
          number: 0,
          text: this.$t("live.blue"),
        },
        {
          a: require("./img/colorful2-start.png"),
          b: require("./img/colorful2-end.png"),
          number: 0,
          text: this.$t("live.pink"),
        },
        {
          a: require("./img/colorful3-start.png"),
          b: require("./img/colorful3-end.png"),
          number: 0,
          text: this.$t("live.orange"),
        },
      ],
      // colorfulTextColor: ["#113BD0", "#E41EB1", "#FF6B00"],
      isSpeakerShow: false,
      colorfulSelected: 0,
      isGiftPlaying: false,
      // isContinuousGift: false,
      // isJoinRoom: false,
      mountImg: require("@/assets/img/mount-animation/zhirehuohu/zhirehuohu1_0000.png"),
      isMountAnimationShow: false,
      nobleBadge: [
        require("./img/knight.png"),
        require("./img/duke.png"),
        require("./img/emperor.png"),
      ],
      isBottom: true,
      // disabledSendMsg: false,
      isWelcomeShow: false,
      // welcomeMsg: [],
      welcomeTimer: null,
      ruleForm: {
        time: "",
        reason: "",
      },
      rules: {
        time: [{ required: true, message: "", trigger: "change" }],
        reason: [{ required: true, message: "", trigger: "change" }],
      },
      bannedTimeList: [
        { name: this.$t("block.30"), value: 30 * 60 },
        { name: this.$t("block.2hrs"), value: 3600 * 2 },
        { name: this.$t("block.6hrs"), value: 3600 * 6 },
        { name: this.$t("block.1day"), value: 3600 * 24 },
        { name: this.$t("block.7days"), value: 3600 * 24 * 7 },
        { name: this.$t("block.forever"), value: 4294967295 },
      ],
      bannedReasonList: [
        { name: this.$t("blockReason.1"), value: 1 },
        { name: this.$t("blockReason.2"), value: 2 },
        { name: this.$t("blockReason.3"), value: 3 },
        { name: this.$t("blockReason.4"), value: 4 },
        { name: this.$t("blockReason.5"), value: 5 },
        { name: this.$t("blockReason.6"), value: 6 },
        { name: this.$t("blockReason.7"), value: 7 },
      ],
      isBannedBtnShow: false,
      isBanneding: false,
      firstWellMsg: null,
    };
  },
  beforeDestroy() {
    if (this.liveDetail.anchorid !== this.userInfo.id) {
      this.timQuitGroup();
    }
    this.changeMessageList([]);
    document.removeEventListener("click", this.bodyClosePlugs);
    document.removeEventListener("click", this.bodyCloseClassic);
    // document.removeEventListener("click", this.bodyCloseColorText);
    document.removeEventListener("click", this.bodyCloseShowShield);
  },
  async mounted() {
    this.getUserLevel();

    this.room = this.liveDetail.anchorid || this.roomId;
    console.log(
      this.room,
      this.appConfig.im_sdkappid,
      "this.roomId:::::::::::::::::"
    );

    // if (this.appConfig.im_sdkappid) {
    //   this.initTim();
    // }
    if (this.isTimReady) {
      console.log(this.isTimReady, "isTimReady");
      this.systemTipText = await timJoinGroup(
        this.room,
        this.liveDetail.anchor_name
      );
      // this.initJoinRoom();
    }

    document.addEventListener("click", this.bodyClosePlugs);
    document.addEventListener("click", this.bodyCloseClassic);
    // document.addEventListener("click", this.bodyCloseColorText);
    document.addEventListener("click", this.bodyCloseShowShield);
    this.isGiftBlocked = JSON.parse(localStorage.getItem("isGiftBlocked"));
    this.isNobleBlocked = JSON.parse(localStorage.getItem("isNobleBlocked"));
    if (!this.userInfo.id) {
      this.isColorTextShow = false;
    }
    post({
      url: "/api/lang/search",
      data: {},
    }).then((res) => {
      if (res.data.status === 0) {
        const front = res.data.data[1].format.replace(
          "%s",
          this.liveDetail.anchor_name || this.anchor.nick_name
        );
        const back = res.data.data[2].format.replace(
          "%s",
          this.liveDetail.anchor_name || this.anchor.nick_name
        );
        this.firstWellMsg = { type: "first_wel", content: front + "\n" + back };
      }
    });
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "changeLoginType",
      "changeLiveAd",
      "changeLiveAdContact",
      "pushMessageList",
      "changeMessageList",
    ]),

    // 链接
    formatMsg(msg) {
      console.log(msg, "newStrnewStr");
      const reg =
        /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
      const strValue = msg.match(reg);
      if (strValue && strValue.length > 0) {
        let newStr = "";
        strValue.forEach((ele, index) => {
          newStr = msg.replace(
            strValue[index],
            `<a class="link_rich_a" href=${strValue[index]} target="_blank">${strValue[index]}</a>`
          );
        });

        return newStr.indexOf("\n") > -1 ? "\n" + newStr : newStr;
      }
      return msg.indexOf("\n") > -1 ? "\n" + msg : msg;
    },

    // 消息风险控制器
    msgRiskControl(msg = "") {
      // 如果是房管 不受风控限制
      if (this.loginRepData.user.role === 3) {
        return true;
      }

      // 被禁言
      if (this.disabledSendMsg) {
        this.$emit("showToast", this.$t("chat.bannedDone"));
        // this.checkUserIsDisabled()
        // 被禁言重置次数
        localStorage.removeItem("t_vio");
        localStorage.removeItem("c_vio");
        localStorage.removeItem("n_vio");
        return false;
      }

      // 1.如果 发言频率开关开启并且发言间隔在 chatConfig.speak_rate 秒内 toast 提示 您发言太频繁，请稍后再试
      const lastSendTime = Number(sessionStorage.getItem("send-time") || "0");
      if (
        this.chatConfig.toggle_speak_rate === 1 &&
        Date.now() - lastSendTime <= this.chatConfig.speak_rate * 1000
      ) {
        this.$emit("showToast", this.$t("chat.more"));
        return false;
      }

      // 2.单条消息连续数字长度开关开启 toggle_single_msg === 1
      if (this.chatConfig.toggle_single_msg === 1) {
        // 如果连续的数字大于配置的最大长度 single_msg_num_length
        const reg = new RegExp(
          `[0-9]\\d{${this.chatConfig.single_msg_num_length},}`,
          "g"
        );
        const nums = msg.match(reg);
        if (nums) {
          // 累计触发风控次数+1
          const total_violation =
            Number(localStorage.getItem("t_vio") || "0") + 1;
          // 连续触发风控次数+1
          const continuous_violation =
            Number(localStorage.getItem("c_vio") || "0") + 1;

          localStorage.setItem("t_vio", total_violation.toString());
          localStorage.setItem("c_vio", continuous_violation.toString());
          // 连续触发次数 + 1，跳过一条无违规消息后清0

          // 如果累计风控开关开启 并且 累计违规次数大于 total_trigger 禁言
          if (
            this.chatConfig.toggle_total_trigger === 1 &&
            total_violation >= this.chatConfig.total_trigger
          ) {
            this.rickSelf(msg, this.chatConfig.total_trigger_banned);
            return false;
          }

          // 如果连续触发风控开关开启 并且 连续违规次数大于 continue_trigger_num 禁言
          if (
            this.chatConfig.toggle_continue_trigger === 1 &&
            continuous_violation >= this.chatConfig.continue_trigger_num
          ) {
            this.rickSelf(msg, this.chatConfig.continue_trigger_banned);
            return false;
          }

          this.$emit("showToast", this.$t("chat.banned"));
          return false;
        }
      }

      // 3 连续纯数字消息条数 > toggle_num_msg_count 算触发一次风控  如果开启了 连续数字消息限制 toggle_num_msg_count
      if (this.chatConfig.toggle_num_msg_count === 1) {
        // 如果当前消息是纯数字消息
        if (/^\d+$/g.test(msg)) {
          // 连续发送纯数字次数+1
          const number_violation =
            Number(localStorage.getItem("n_vio") || "0") + 1;

          localStorage.setItem("n_vio", number_violation.toString());

          // 如果 连续发送纯数字次数 > num_msg_count 触发总风控次数+1
          if (number_violation > this.chatConfig.num_msg_count) {
            // 累计触发风控次数+1
            const total_violation =
              Number(localStorage.getItem("t_vio") || "0") + 1;
            // 连续触发风控次数+1
            const continuous_violation =
              Number(localStorage.getItem("c_vio") || "0") + 1;

            localStorage.setItem("t_vio", total_violation.toString());
            localStorage.setItem("c_vio", continuous_violation.toString());

            // 连续数字消息从0开始重新计算
            localStorage.setItem("n_vio", "0");
            // 如果累计风控开关开启 并且 累计违规次数大于 total_trigger 禁言
            if (
              this.chatConfig.toggle_total_trigger === 1 &&
              total_violation >= this.chatConfig.total_trigger
            ) {
              this.rickSelf(msg, this.chatConfig.total_trigger_banned);
              return false;
            }

            // 如果连续触发风控开关开启 并且 连续违规次数大于 continue_trigger_num 禁言
            if (
              this.chatConfig.toggle_continue_trigger === 1 &&
              continuous_violation >= this.chatConfig.continue_trigger_num
            ) {
              this.rickSelf(msg, this.chatConfig.continue_trigger_banned);
              return false;
            }

            this.$emit("showToast", this.$t("chat.banned"));
            return false;
          }
        } else {
          localStorage.setItem("n_vio", "0");
        }
      }

      // const urlReg = /(https?:\/\/)?((([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?/g;
      const urlReg = /(https?:\/\/)?[a-zA-Z0-9]+\.\w{2,6}/g;

      if (this.chatConfig.toggle_link_set === 1 && urlReg.test(msg)) {
        // 累计触发风控次数+1
        const total_violation =
          Number(localStorage.getItem("t_vio") || "0") + 1;
        // 连续触发风控次数+1
        const continuous_violation =
          Number(localStorage.getItem("c_vio") || "0") + 1;

        localStorage.setItem("t_vio", total_violation.toString());
        localStorage.setItem("c_vio", continuous_violation.toString());
        // 如果累计风控开关开启 并且 累计违规次数大于 total_trigger 禁言
        if (
          this.chatConfig.toggle_total_trigger === 1 &&
          total_violation >= this.chatConfig.total_trigger
        ) {
          this.rickSelf(msg, this.chatConfig.total_trigger_banned);
          return false;
        }

        // 如果连续触发风控开关开启 并且 连续违规次数大于 continue_trigger_num 禁言
        if (
          this.chatConfig.toggle_continue_trigger === 1 &&
          continuous_violation >= this.chatConfig.continue_trigger_num
        ) {
          this.rickSelf(msg, this.chatConfig.continue_trigger_banned);
          return false;
        }

        this.$emit("showToast", this.$t("chat.disabledLink"));
        return false;
      }

      // 无违规 连续违规数清 0
      localStorage.setItem("c_vio", "0");
      return true;
    },

    // 禁言1小时
    rickSelf(msg, time) {
      let message = tim.createCustomMessage({
        to: "admin",
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify({
            type: "banSelf",
            groupId: this.liveDetail.anchorid || this.roomId || 0,
            t_ban: time * 3600,
            ban_msg: msg,
          }),
        },
      });
      // 2. 发送消息
      tim.sendMessage(message).then((res) => {
        if (res.code === 0) {
          console.log("rickSelf=======>", res);

          this.disabledSendMsg = true;
          this.$emit("showToast", this.$t("chat.bannedTime", { num: time }));
        }
      });
    },

    // 检测当前用户是否被禁言
    checkUserIsDisabled() {
      post({
        url: "/api/live/checkIsMgr",
        data: { anchorid: this.roomId, target_user_id: this.userInfo.id },
      }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};
          if (res.status === 0) {
            const { target_user_is_banned } = res.data || {};
            // 1已禁言 2未禁言
            if (target_user_is_banned === 2) {
              this.disabledSendMsg = false;
            }
          }
        }
      });
    },

    fontColorToLinearGradient,
    fontColorToBackgroundColor,
    levelToLinearGradient,
    levelToFontColor,

    addPaddingRight(boo) {
      if (boo) {
        return { paddingRight: "0.4rem" };
      }
    },
    toGeneralFont() {
      if (this.messageContent === "") {
        this.showColorText();
      }
    },
    formatMessage() {
      if (this.messageContent.length > 50 && this.loginRepData.user.role < 2) {
        this.messageContent = this.messageContent.slice(0, 50);
        this.$emit("showToast", this.$t("chat.max"));
      }
    },
    getUserLevel() {
      this.level = this.userInfo.level;
      let storeColor = JSON.parse(localStorage.getItem("activeTextColor"));

      if (this.level < 2) {
        this.activeTextColor = 0;
      }
      if (this.level >= 2) {
        this.activeTextColor = 1;
      }
      if (this.level >= 8) {
        this.activeTextColor = 2;
      }
      if (this.level >= 16) {
        this.activeTextColor = 3;
      }
      if (this.level === 21) {
        this.activeTextColor = 4;
      }
      if (storeColor !== null && storeColor <= this.activeTextColor) {
        this.activeTextColor = storeColor;
      }
    },
    changeTextColor(index, lv) {
      console.log(index, lv, "index, lv");
      if (this.level >= lv) {
        this.activeTextColor = index;
        localStorage.setItem("activeTextColor", this.activeTextColor);
      }
    },

    nextLine() {
      this.messageContent = this.messageContent + "\n";
    },

    sendMsg() {
      if (this.loginRepData.type !== "loginRep") return;
      if (!this.userInfo.id) {
        this.changeLoginType("login");
        this.toggleLogin();
        return;
      }

      if (!this.messageContent.trim()) {
        this.messageContent = "";
        this.$emit("showToast", this.$t("chat.empty"));
        return;
      }

      // 发送消息
      const msg = {
        type: "say",
        content: this.messageContent.trim(),
      };

      // 发送消息风险控制
      if (!this.msgRiskControl(msg.content)) return;

      this.timSend(msg);
      this.messageContent = "";

      console.log(msg, this.room, "roomid msg");
    },

    timSend(msg) {
      // msg = JSON.stringify(msg);
      this.loginRepData.user.font_color = this.colorInput[this.activeTextColor];
      console.log(this.loginRepData, "this.loginRepData");
      let props = JSON.stringify(this.loginRepData.user);
      let message = tim.createTextMessage({
        to: String(this.room),
        // to: "123",
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
          text: msg.content,
        },
        cloudCustomData: props,
      });
      // 2. 发送消息
      console.log(message, "createTextMessage");
      msg = { ...msg, ...this.loginRepData.user };
      msg.from_client_name = message.nick;
      msg.messageId = message.ID;
      if (this.isColorfulShow) {
        msg.textColor = this.colorfulTextColor[this.colorfulSelected];
      } else {
        msg.textColor = this.colorInput[this.activeTextColor];
      }
      msg.isSpeaker = this.isSpeakerShow;
      msg.isColorful = this.isColorfulShow;
      let msgLength = this.messageList.length;
      this.pushMessageList(msg);
      // this.messageList.push(msg);
      // this.$emit("sendDanmu", this.messageList);
      this.toBottom();
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          if (imResponse.code == 0) {
            this.messageList[msgLength].id = message.sequence; //临时直接修改vuex
            console.log(this.messageList[msgLength], "发送成功");
            // 记录发送消息时间
            sessionStorage.setItem("send-time", Date.now().toString());
          }
        })
        .catch((imError) => {
          // 发送失败
          this.errorMessageIds.push(message.ID);
          console.log("sendMessage error:", this.errorMessageIds, imError.code);
          if (imError.code === 10017) {
            this.bannedMessage();
          } else if (imError.code === 3003) {
            this.$message.error(this.$t("chat.loginOut"));
            this.errorMsg = this.$t("chat.loginOut");
          } else if (imError.code === 2100) {
            this.$message.error(this.$t("chat.tryAgain"));
            this.errorMsg = this.$t("chat.tryAgain");
          } else {
            this.errorMsg = imError.message;
            this.$message.error(imError.message);
          }
        });
    },
    async bannedMessage() {
      const {
        data: { data },
      } = await post({
        url: "/api/live/checkIsMgr",
        data: {
          anchorid: this.liveDetail.anchorid || this.roomId || 0,
          target_user_id: this.userInfo.id,
        },
      });
      let error = "";
      console.log(data, "datadatadata");
      if (Number(data.reason) > 6) {
        error = this.$t("chat.ban7", { num: data.time_msg });
      } else {
        error = this.$t(`chat.ban${data.reason}`, { num: data.time_msg });
      }

      this.errorMsg = error;
      this.$message.error(error);
    },

    sendProps() {
      if (this.loginRepData.type !== "loginRep") return;
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      console.log(
        this.colorfulSelected,
        this.props.colorful1,
        "this.colorfulSelected"
      );
      if (
        this.colorfulSelected == 0 &&
        !this.props.colorful1 &&
        this.isColorfulSelectShow
      ) {
        this.isColorTextShow = true;
        this.isColorfulShow = false;
        this.isColorfulSelectShow = false;
        this.$emit("showToast", this.$t("chat.no1"));
        return;
      }
      if (
        this.colorfulSelected == 1 &&
        !this.props.colorful2 &&
        this.isColorfulSelectShow
      ) {
        this.isColorTextShow = true;
        this.isColorfulShow = false;
        this.isColorfulSelectShow = false;
        this.$emit("showToast", this.$t("chat.no1"));
        return;
      }
      if (
        this.colorfulSelected == 2 &&
        !this.props.colorful3 &&
        this.isColorfulSelectShow
      ) {
        this.isColorTextShow = true;
        this.isColorfulShow = false;
        this.isColorfulSelectShow = false;
        this.$emit("showToast", this.$t("chat.no1"));
        return;
      }
      if (!this.props.speaker && this.isSpeakerShow) {
        this.isColorTextShow = true;
        this.isSpeakerShow = false;
        this.$emit("showToast", this.$t("chat.no2"));
        return;
      }

      // 发送消息
      let msg = {
        type: "props",
        content: this.messageContent.trim(),
        props_id: this.isColorfulSelectShow ? this.colorfulSelected + 2 : 5,
        props_type: this.isColorfulSelectShow ? 101 : 100,
        count: 1,
        // user_id: this.userInfo.id,
        uid: this.userInfo.id,
        extra_data: "",
      };
      if (!this.messageContent.trim()) {
        this.messageContent = "";
        this.$emit("showToast", this.$t("chat.empty"));
        return;
      }

      // 风险控制
      if (!this.msgRiskControl(msg.content)) return;

      this.messageContent = "";

      let msgJson = JSON.stringify(msg);
      console.log(msgJson, "道具消息==========");
      let message = tim.createCustomMessage({
        to: String(this.room),
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
          data: msgJson,
        },
      });
      msg = { ...msg, ...this.loginRepData.user };
      if (this.isSpeakerShow) {
        msg.isSpeaker = true;
        msg.from_client_name = message.nick;
        // this.$emit("sendDanmu", msg);
      }
      let msgLength;
      if (this.isColorfulSelectShow) {
        msg.isColorful = true;
        msg.textColor = this.colorfulTextColor[this.colorfulSelected];
        msg.from_client_name = message.nick;
        msg.messageId = message.ID;
        msg.type = "say";
        msgLength = this.messageList.length;
        // this.pushMessageList(msg);
        // this.$emit("sendDanmu", this.messageList);
        this.toBottom();
      }
      this.pushMessageList(msg);

      if (!(this.colorfulSelected == 0 && this.isColorfulSelectShow)) {
        this.isColorTextShow = true;
        this.isColorfulShow = false;
        this.isSpeakerShow = false;
        this.isColorfulSelectShow = false;
      }

      // 2. 发送消息
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          if (imResponse.code == 0) {
            console.log(imResponse, message, this.colorfulSelected, "发送成功");
            if (this.isColorfulShow) {
              this.messageList[msgLength].id = message.sequence; //临时直接修改vuex
            }
            this.$emit("reloadBackpack");
          }
        })
        .catch((imError) => {
          // 发送失败
          this.errorMessageIds.push(message.ID);
          if (imError.code == 10017) {
            this.bannedMessage();
          } else if (imError.code === 3003) {
            this.$message.error(this.$t("chat.loginOut"));
            this.errorMsg = this.$t("chat.loginOut");
          } else if (imError.code === 2100) {
            this.$message.error(this.$t("chat.tryAgain"));
            this.errorMsg = this.$t("chat.tryAgain");
          } else {
            this.errorMsg = imError.message;
            this.$message.error(imError.message);
          }
        });
    },

    timQuitGroup() {
      let promise = tim.quitGroup(String(this.room));
      promise
        .then((imResponse) => {
          console.log("退群成功 ==============>", imResponse.data.groupID);
        })
        .catch((imError) => {
          console.warn("quitGroup error:", imError); // 退出群组失败的相关信息
        });
      // tim.destroy().then(() => {
      //   console.log("sdk destroyed");
      // });
    },

    timSendBanned(msg) {
      msg = JSON.stringify(msg);
      console.log(msg, "msg banned");
      let message = tim.createCustomMessage({
        to: "admin",
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          data: msg,
        },
      });
      // 2. 发送消息
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          if (imResponse.code == 0) {
            this.isBanneding = false;
            let type = JSON.parse(imResponse.data.message.payload.data).type;
            console.log(type, "banned type sent =>");
            if (type == "bannedUser") {
              this.isBlockUserStep1 = false;
              this.$message.success(this.$t("chat.bannerSuccess"));
            } else if (type == "unbannedUser") {
              this.$message.success(this.$t("chat.unBanner"));
            }
          }
        })
        .catch((imError) => {
          // 发送失败
          console.log("sendBanned error:", imError);
          this.$message.error(imError.message);
        });
    },
    popupDeleteMsg(item) {
      console.log(item, "popupDeleteMsg");
      if (this.loginRepData.user.role > 1) {
        this.isDeleteMsg = true;
        this.userMessage = item;
      }
    },
    showErrorMsg() {
      this.$message.error(this.errorMsg);
    },

    deleteMessage() {
      if (this.isBanneding) return;
      this.isBanneding = true;
      console.log(this.userMessage, "this.userMessage");
      this.deleteMsgId = this.userMessage.id;
      this.timSendBanned({
        type: "clear",
        chat_id: this.userMessage.id,
        user_id: this.userMessage.user_id,
        room_id: this.liveDetail.anchorid || this.roomId || 0,
      });
      this.isDeleteMsg = false;
    },

    async popupBlockUserStep1(item) {
      console.log(
        item,
        this.loginRepData.user.role,
        this.liveDetail.anchorid,
        "item:::::::::::::::::::::::::::::"
      );
      if (
        (this.loginRepData.user.role > 1 && item.role < 2) ||
        (this.loginRepData.user.role > 1 && item.type === "bannedUser")
      ) {
        const {
          data: { data },
        } = await post({
          url: "/api/live/checkIsMgr",
          data: {
            anchorid: this.liveDetail.anchorid || this.roomId || 0,
            target_user_id: item.user_id || item.uid || item.data[0].sender,
          },
        });
        this.userMessage = item;
        this.bannedUser = data;
        this.bannedUserLevel = require(`@/assets/img/level1/lv${data.target_user_level}.png`);
        if (data.target_user_vip_title == 0) {
          this.bannedUserNoble = require("@/assets/img/noble/0.png");
        } else {
          this.bannedUserNoble = require(`@/assets/img/noble/${data.target_user_vip_title}.png`);
        }
        if (data.target_user_is_banned == 1) {
          this.isUnblockUser = true;
        } else {
          this.isBlockUserStep1 = true;
        }
      }
    },

    changeBannedTime(e) {
      console.log(e);
      this.bannedTime = e;
      if (this.bannedTime && this.bannedReason) {
        this.isBannedBtnShow = true;
      }
    },
    changeBannedReason(e) {
      console.log(e.label, e.value);
      this.bannedReason = e;
      if (this.bannedTime && this.bannedReason) {
        this.isBannedBtnShow = true;
      }
    },

    changeDuration(index, time) {
      this.durationSelect = index;
      this.bannedTime = time;
    },
    blockUserConfirm() {
      if (this.isBanneding) return;
      this.isBanneding = true;
      console.log(this.userMessage, "this.userMessage");
      this.timSendBanned({
        type: "bannedUser",
        user_id: this.userMessage.user_id || this.userMessage.uid,
        mgrid: this.userInfo.id,
        ban_time: this.bannedTime,
        reason: this.bannedReason.label,
        ban_type: this.bannedReason.value,
        ban_msg: this.userMessage.content,
        groupId: this.room,
        room_id: this.room,
        banned_area: 0,
        requestId: 1,
      });
      this.isBlockUserStep2 = false;
    },
    unblockUser() {
      if (this.isBanneding) return;
      this.isBanneding = true;
      console.log(this.userMessage, "this.userMessage");
      this.timSendBanned({
        type: "unbannedUser",
        user_id: this.userMessage.user_id || this.userMessage.uid,
        mgrid: this.userInfo.id,
        ban_time: this.bannedTime,
        reason: this.bannedReason.label || "",
        ban_type: this.bannedReason.value || 0,
        ban_msg: this.userMessage.content,
        groupId: this.room,
        room_id: this.room,
        banned_area: 0,
        requestId: 1,
      });
      this.isUnblockUser = false;
    },
    blockGiftAnimation() {
      this.isGiftBlocked = !this.isGiftBlocked;
      localStorage.setItem("isGiftBlocked", this.isGiftBlocked);
      console.log("this.isGiftBlocked", this.isGiftBlocked);
      if (this.isGiftBlocked) {
        this.clearAnimation();
      }
    },
    blockNobleAnimation() {
      this.isNobleBlocked = !this.isNobleBlocked;
      localStorage.setItem("isNobleBlocked", this.isNobleBlocked);
    },
    move(i, code) {
      if (code != 1) {
        this.$refs.box1[i].style.cssText = "cursor:not-allowed";
      }
    },
    transNumberToPicture,
    plugCheckbox(e, id) {
      console.log(id);
    },

    bodyClosePlugs() {
      this.isShowPlug = false;
    },
    bodyCloseClassic() {
      this.isClassicShow = false;
    },
    bodyCloseColorText() {
      this.isColorTextShow = false;
    },
    bodyCloseShowShield() {
      // this.isShowShield = false;
      // this.isColorTextShow = true;
      // this.isColorfulShow = false;
      // this.isSpeakerShow = false;
    },

    showProps(type, id) {
      // if (this.props.colorful1 > 0) return;
      if (type === 100) {
        this.isSpeakerShow = true;
        this.isColorfulShow = false;
        this.isColorfulSelectShow = false;
        this.isColorTextShow = false;
      }
      if (type === 101) {
        this.colorfulSelected = id - 2;
        this.isColorfulSelectShow = true;
        this.isColorfulShow = false;
        this.isSpeakerShow = false;
        this.isColorTextShow = false;
        this.$refs.sendMsgInput.focus();
      }
    },
    showColorText() {
      if (!this.userInfo.id) {
        this.showLogin();
        return;
      }
      this.isColorTextShow = true;
      this.isColorfulShow = false;
      this.isSpeakerShow = false;
      this.isShowPlug = false;
      this.isShowShield = false;
      this.isColorfulSelectShow = false;
    },
    showSpeaker() {
      if (!this.userInfo.id) {
        this.showLogin();
        return;
      }
      if (this.props.speaker > 0) {
        this.isSpeakerShow = !this.isSpeakerShow;
        this.isColorfulShow = false;
        if (this.isSpeakerShow) {
          this.isColorTextShow = false;
        } else {
          this.isColorTextShow = true;
        }
        this.isShowShield = false;
        this.isColorfulSelectShow = false;
      } else {
        this.$emit("showToast", this.$t("chat.notenough"));
      }
    },
    showColorful() {
      if (!this.userInfo.id) {
        this.showLogin();
        return;
      }
      this.isColorfulShow = !this.isColorfulShow;
      this.isColorfulSelectShow = true;
      this.isSpeakerShow = false;
      this.isColorTextShow = false;
      // if (this.isColorfulShow) {
      //   this.isColorTextShow = false;
      // } else {
      //   this.isColorTextShow = true;
      // }
      this.isShowShield = false;
    },

    showShield() {
      if (this.userInfo.id) {
        this.isShowShield = !this.isShowShield;
        // if (this.isShowShield) {
        //   this.isColorTextShow = false;
        // } else {
        //   this.isColorTextShow = true;
        // }
        // this.isSpeakerShow = false;
        // this.isColorfulShow = false;
      } else {
        this.showLogin();
      }
    },

    changeColorful(index, number) {
      if (!number) {
        this.$emit("showToast", this.$t("chat.no1"));
        this.isColorTextShow = true;
        this.isColorfulSelectShow = false;
        this.isSpeakerShow = false;
        this.isColorfulShow = false;
        return;
      }
      this.colorfulSelected = index;
      this.isColorfulSelectShow = true;
      this.isColorfulShow = false;
      if (this.isColorfulSelectShow) {
        this.isColorTextShow = false;
      } else {
        this.isColorTextShow = true;
      }
      this.$refs.sendMsgInput.focus();
    },

    async setMyPlug(type, id, sel, unlocked, i) {
      if (unlocked != 1) {
        return;
      }
      if (sel == 1) {
        sel = 2;
      }
      if (sel == 0) {
        sel = 1;
      }
      let ids = [];
      ids.push(id);
      console.log(ids);
      // this.isShowPlug = false;
      this.isClassicShow = false;
      this.isColorTextShow = false;
      const { data } = await post({
        url: "/api/live/user_set_backpack",
        data: {
          ids: ids,
          type: type,
          user_id: this.userInfo.id,
          sel: sel,
        },
      });
      this.$message.success(this.$t("chat.setting"));
      this.$nextTick(() => {
        this.plugList = [];
        this.bgColorList = [];
        this.fontColorList = [];
        this.getPlug();
      });
    },

    async getPlug() {
      this.isloadPlug = true;
      const {
        data: { data },
      } = await post({
        url: "/api/live/user_backpack",
        data: {
          Uid: this.userInfo.id,
        },
      });
      console.log(data);
      const usersData = JSON.parse(JSON.stringify(data.user_backpack));
      const propsData = JSON.parse(JSON.stringify(data.props));
      propsData?.forEach((i) => {
        usersData?.forEach((j) => {
          if (i.id == j.gid) {
            i.unlocked = 1;
            i.id = j.id;
            i.selected = j.selected;
          }
        });
        if (i.type == 1) {
          this.plugList.push(i);
        }
        if (i.type == 2) {
          this.bgColorList.push(i);
        }
        if (i.type == 3) {
          this.fontColorList.push(i);
        }
      });
    },

    showLogin() {
      this.changeLoginType("login");
      this.toggleLogin();
    },
    changeEmojiCategory(category) {
      this.emojiCategory = category;
    },
    insert(emoji) {
      this.messageContent += emoji;
    },

    clearContent() {
      this.messageList = [];
      this.isShowText = false;
    },

    onscroll() {
      // 是否滚动到了底部
      this.chatBox = this.$refs.chatMess;
      let clientHeight = this.chatBox?.clientHeight;
      let scrollTop = this.chatBox?.scrollTop;
      let scrollHeight = this.chatBox?.scrollHeight;
      // console.log(scrollTop + clientHeight);
      // console.log(scrollHeight, "-scrollHeight");
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        // console.log("objectshang");
        this.showMoreMsg = false;
        this.isBottom = true;
      } else {
        this.isBottom = false;
        // if (this.newMessage === true) {
        //   this.showMoreMsg = true;
        // }
      }
    },

    toBottom() {
      this.$nextTick(() => {
        // this.$refs["chatMess"].scrollIntoView();
        if (this.$refs["chatMess"]) {
          this.$refs["chatMess"].scrollTop =
            this.$refs["chatMess"].scrollHeight;
        }
        this.showMoreMsg = false;
        this.isBottom = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.chat-room {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  position: relative;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}

.system_tip {
  font-size: 0.14rem;
  color: #33cc00;
  line-height: 0.2rem;
  position: relative;
  margin-bottom: 0.08rem;
  padding: 0 0.12rem;
}
.chat-loading {
  flex: 1;
  text-align: center;
  margin-top: 40%;
  color: #333333;
}
.chat_content {
  flex: 1;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  overflow-y: auto;
  position: relative;
  // padding: 0 0.12rem;
  background: #fff;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
  .disable_pop {
    position: absolute;
    z-index: 10;
    left: 0;
    top: -0.86rem;
    width: 1.44rem;
    border-radius: 8px;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    padding-bottom: 0.12rem;
    > .top {
      padding-top: 0.12rem;
      text-align: center;
      position: relative;
      .del {
        position: absolute;
        top: 2px;
        right: 2px;
        color: #969db0;
        font-size: 19px;
        cursor: pointer;
        background: linear-gradient(90deg, #ffac04 0%, #eecb84 100%);
      }
    }
    .user_name {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      font-weight: 500;
    }
    .confirm_btn {
      width: 88px;
      height: 24px;
      background: #26d99d;
      border-radius: 12px;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      margin: 0 auto;
      margin-top: 14px;
      cursor: pointer;
    }

    .bottom-arrow {
      width: 100%;
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background: #26d99d;
      border-radius: 0 0 4px 4px;

      &::before {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        bottom: -16px;
        left: 25%;
        border: 8px solid transparent;
        border-top: 8px solid #26d99d;
      }

      &::after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        bottom: -10px;
        left: 25%;
        border: 8px solid transparent;
        border-top: 8px solid #fff;
      }
    }
  }

  .chat_item {
    font-size: 0.14rem;
    line-height: 0.32rem;
    position: relative;
    margin-bottom: 0.02rem;

    .chat {
      position: relative;
      // padding: 0.01rem 0;
      padding-left: 0.12rem;
      background: linear-gradient(
        0deg,
        rgba(174, 174, 174, 0.05),
        rgba(174, 174, 174, 0.05)
      );

      .colorful-bar {
        width: 0.04rem;
        height: 100%;
        position: absolute;
        left: 0;
      }
      .pendant {
        display: inline;
      }
      .level {
        display: inline-block;
        width: 0.4rem;
        height: 0.18rem;
        line-height: 0.18rem;
        text-align: center;
        // background: linear-gradient(180deg, #ffa000 0%, #ffe600 100%);
        border-radius: 0.02rem;
        color: #ffffff;
        font-size: 0.12rem;
        transform: scale(0.8);
        vertical-align: middle;
      }
      .noble {
        width: 0.24rem;
        height: 0.24rem;
      }
      .room-anchor {
        height: 0.24rem;
      }
      .room-manager {
        width: 0.24rem;
        height: 0.14rem;
        margin-left: 0.02rem;
      }
      .anchor_box {
        display: inline-block;
        height: 0.16rem;
        line-height: 0.16rem;
        text-align: center;
        color: #ffffff;
        vertical-align: middle;
        margin-right: 0.08rem;
        .anchor {
          background: linear-gradient(253deg, #ff81b6 6.65%, #ff008a 79.17%);
          border-radius: 0.08rem;
          height: 0.16rem;
          line-height: 0.16rem;
          display: flex;
          align-items: center;
          padding: 0 0.05rem;
          img {
            width: 0.18rem;
            height: 0.18rem;
            margin-left: -0.04rem;
          }
          span {
            font-size: 0.12rem;
          }
        }
      }
      .manager_box {
        display: inline-block;
        margin-right: 0.08rem;
        vertical-align: middle;
        .manager {
          height: 0.18rem;
          border-radius: 1rem;
          border: 0.02rem solid #ffa62b;
          background: linear-gradient(0deg, #922c00 0%, #b13803 100%);
          padding: 0 0.08rem;
          line-height: 0.18rem;
          display: flex;
          align-items: center;
          img {
            width: 0.1rem;
            height: 0.1rem;
            margin-right: 0.02rem;
          }
          span {
            color: #fff;
            font-size: 0.1rem;
            font-weight: 400;
          }
        }
      }
      .colorful-char {
        width: 0.5rem;
        height: 0.34rem;
        // float: right;
        position: absolute;
        top: 0;
        right: 0;
      }
      .left {
        color: #8393bc;
        cursor: pointer;
      }
      .me {
        // margin-left: .08rem;
        color: #02a8a2;
      }
      .right {
        color: #333333;
        word-break: break-all;
        cursor: pointer;
        white-space: pre-wrap;
      }

      .mr-8 {
        margin-right: 0.08rem;
      }

      .send-gift {
        font-size: 0.16rem;
        color: #26d99d;
      }
      .error-dot {
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 0.16rem;
        background-color: red;
      }
      .gift-icon {
        width: 0.24rem;
        height: 0.24rem;
        margin: 0 0.05rem;
      }
    }
  }
}
.welcome-border {
  width: 3.4rem;
  height: 0.02rem;
  background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
}
.welcome-list {
  width: 3.4rem;
  height: 0.32rem;
  overflow: scroll;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}
.welcome {
  width: 3.4rem;
  height: 0.32rem;
  background: linear-gradient(
    0deg,
    rgba(2, 168, 162, 0.08),
    rgba(2, 168, 162, 0.08)
  );
  padding-left: 0.12rem;
  display: flex;
  align-items: center;
  .welcome-level {
    width: 0.4rem;
    height: 0.18rem;
    line-height: 0.18rem;
    text-align: center;
    border-radius: 0.02rem;
    color: #ffffff;
    font-size: 0.12rem;
    transform: scale(0.8);
    margin-right: 0.05rem;
    background: linear-gradient(352.91deg, #cae6ff 1.35%, #6171ff 94.86%);
  }
  .welcome-name {
    color: #8393bc;
    font-size: 0.14rem;
    margin-right: 0.05rem;
  }
  .welcome-msg {
    color: #999999;
  }
}
.delete-msg {
  width: 2.5rem;
  position: absolute;
  top: 50%;
  left: 0.45rem;
  transform: translate(0, -50%);
  box-shadow: 0px 0px 30px rgba(1, 0, 61, 0.2);
  background: #fff;
  z-index: 1;
  .delete-msg-header {
    padding: 0 0.12rem;
    height: 0.36rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, #fd3061 0%, #d12e55 100%);
    border-radius: 0.05rem 0.05rem 0px 0px;
    font-size: 0.14rem;
    color: #ffffff;
    img {
      width: 0.12rem;
      height: 0.12rem;
      cursor: pointer;
    }
  }
  .delete-msg-content {
    padding: 0.2rem 0.1rem 0.2rem 0.1rem;
    border-radius: 0px 0px 0.05rem 0.05rem;
    .content {
      width: 100%;
      padding: 0.12rem;
      background: #f9f9fb;
      color: #333;
      line-height: 0.22rem;
      span {
        color: #8393bc;
      }
    }
    .delete_btn {
      height: 0.34rem;
      border-radius: 1rem;
      padding: 0 0.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(208, 45, 84, 1);
      cursor: pointer;
      img {
        width: 0.2rem;
        margin-right: 0.06rem;
      }
      span {
        color: rgba(208, 45, 84, 1);
        font-size: 0.14rem;
      }
    }
  }
}

::v-deep .el-form-item {
  margin-bottom: 0.05rem;
}
::v-deep .el-form-item__label {
  font-size: 0.12rem;
  margin-left: 0.25rem;
}
::v-deep .el-input__inner {
  width: 1.3rem;
  height: 0.26rem;
  line-height: 0.26rem;
  padding-left: 0.05rem;
  font-size: 0.12rem;
}
.block-user-step1 {
  width: 2.5rem;
  /* height: 3.26rem; */
  position: absolute;
  top: 50%;
  left: 0.45rem;
  transform: translate(0, -50%);
  box-shadow: 0px 0px 30px rgba(1, 0, 61, 0.2);
  background: #fff;
  border-radius: 10px;
  z-index: 1;
  .header {
    padding-right: 0.12rem;
    padding-top: 0.12rem;
    display: flex;
    justify-content: flex-end;
    img {
      width: 0.12rem;
      height: 0.12rem;
      cursor: pointer;
    }
  }
  .logo {
    display: flex;
    justify-content: center;
    .img1 {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
    }
    .img2 {
      position: absolute;
      width: 0.64rem;
      height: 0.64rem;
      left: 0.93rem;
      top: 0.22rem;
    }
  }
  .name {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    color: #333;
    font-size: 0.16rem;
    img {
      height: 0.18rem;
      margin-left: 0.03rem;
    }
  }
  .btn {
    width: 1.12rem;
    height: 0.34rem;
    background: #c4cacc;
    color: #fff;
    font-size: 0.16rem;
    border-radius: 0.34rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.2rem auto 0;
    cursor: not-allowed;
  }
  .btn-active {
    cursor: pointer;
    background: linear-gradient(90deg, #fd3061 0%, #d12e55 100%);
  }
}
.unblock-user {
  height: 2.14rem;
  .btn {
    cursor: pointer;
  }
}
.block-user-step2 {
  width: 2.5rem;
  position: absolute;
  top: 50%;
  left: 0.45rem;
  transform: translate(0, -50%);
  box-shadow: 0px 0px 30px rgba(1, 0, 61, 0.2);
  background: #fff;
  border-radius: 10px;
  .header {
    padding: 0 0.12rem;
    height: 0.36rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #02a8a2;
    border-radius: 0.05rem 0.05rem 0px 0px;
    font-size: 0.14rem;
    color: #ffffff;
    img {
      width: 0.12rem;
      height: 0.12rem;
      cursor: pointer;
    }
  }
  .content {
    display: flex;
    align-items: center;
    height: 0.43rem;
    color: #333;
    font-size: 0.14rem;
    border-bottom: 0.005rem solid #f0f0f0;
    cursor: pointer;
    img {
      width: 0.2rem;
      height: 0.2rem;
      cursor: pointer;
      margin-right: 0.08rem;
      margin-left: 0.12rem;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.25rem;
    margin: 0.2rem auto;
    .btn {
      width: 0.9rem;
      height: 0.34rem;
      background: #02a8a2;
      color: #fff;
      font-size: 0.16rem;
      border-radius: 0.34rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .btn1 {
      height: 0.32rem;
      color: #02a8a2;
      background: #fff;
      border: 0.01rem solid #02a8a2;
    }
  }
}
.continuous-gift {
  width: 3.4rem;
  position: absolute;
  top: 50%;
  z-index: 3;
  .gift-list {
    width: 3.4rem;
    height: 0.4rem;
    margin-bottom: 0.22rem;
    background: url("./img/gift_bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 0.14rem;
    .a {
      max-width: 1.1rem;
      margin-left: 0.12rem;
    }
    .b {
      font-size: 0.12rem;
      margin: 0 0.08rem;
    }
    .c img {
      height: 0.5rem;
      margin-right: 0.08rem;
    }
    .d img {
      height: 0.17rem;
    }
    .e img {
      width: 0.2rem;
      margin: 0 0.08rem;
    }
    .f img {
      height: 0.32rem;
    }
  }
}
.gift_content {
  width: 3.4rem;
  height: 4.4rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  .gift_conten_img {
    width: 100%;
    height: 100%;
  }
}
.mount-animation {
  width: 3.4rem;
  height: 3.4rem;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  img {
    width: 100%;
    height: 100%;
  }
}

.to_bottom_btn {
  width: 3.4rem;
  height: 0.3rem;
  background: rgba(2, 168, 162, 0.7);
  text-align: center;
  line-height: 0.3rem;
  color: #fff;
  font-size: 0.12rem;
  // position: absolute;
  // top: -0.3rem;
  // left: 50%;
  // transform: translateX(-50%);
  position: relative;
  cursor: pointer;

  &::before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    // top: 60%;
    bottom: 0;
    left: 32%;
    transform: translateY(-50%);
    border: 0.05rem solid transparent;
    border-top: 0.05rem solid #fff;
  }
}

.message_bottom {
  position: relative;
  // height: 1.08rem;
  height: 1rem;
  padding: 0 0.16rem;

  .emoji {
    width: 3.39rem;
    position: absolute;
    top: -1.6rem;
    left: 0;
    background-color: #fff;
    border-top: 0.01rem solid #eee;
  }
  .emoji-cats {
    display: flex;
    .emoji-cat {
      width: 0.85rem;
      height: 0.3rem;
      background-color: #eee;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .emoji-active {
      background-color: #fff;
    }
  }
  .emoji-item {
    height: 1.3rem;
    padding: 0.1rem;
    overflow: scroll;
    span {
      margin: 0.03rem;
      margin-bottom: 0.05rem;
      display: inline-block;
      cursor: pointer;
    }
  }
  .chat-popup {
    width: 3.38rem;
    height: 2.34rem;
    position: absolute;
    top: -2.32rem;
    left: 0;
    background-color: #fff;
    border: 1px solid #dbdbdb;
    border-radius: 0.06rem 0.06rem 0 0;
    .chat-popup-title {
      height: 0.36rem;
      background-color: #f4f4f4;
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      color: #333333;
      padding-left: 0.12rem;
    }
    .chat-popup-classic {
      padding: 0.16rem 0.06rem 0 0.16rem;
      height: 1.96rem;
      display: flex;
      flex-wrap: wrap;
      overflow: scroll;

      .item {
        position: relative;
        width: 1.46rem;
        height: 0.46rem;
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;
        cursor: pointer;
        .item-pic {
          width: 1.49rem;
          height: 0.46rem;
        }
        .item-pic-lock {
          width: 0.33rem;
          height: 0.13rem;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
    .chat-popup-color {
      padding: 0.16rem 0.06rem 0.1rem 0.16rem;
      height: 1.96rem;
      display: flex;
      flex-wrap: wrap;
      overflow: scroll;
      .item {
        position: relative;
        width: 0.6rem;
        height: 0.32rem;
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;
        border-radius: 1rem;
        text-align: center;
        line-height: 0.32rem;
        color: #fff;
        cursor: pointer;
        img {
          width: 0.18rem;
          height: 0.18rem;
          position: absolute;
          right: -0.04rem;
          bottom: -0.03rem;
        }
        .item-pic {
          width: 0.6rem;
          height: 0.32rem;
        }
        .item-pic-lock {
          width: 0.18rem;
          height: 0.18rem;
          position: absolute;
          right: -0.04rem;
          bottom: -0.03rem;
        }
      }
    }
    .chat-popup-pendant {
      display: flex;
      align-items: center;
      width: 100%;
      height: 1.96rem;
      // padding: .1rem;
      overflow: scroll;
      .chat-popups {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        overflow: scroll;
        margin-top: 165px;
        margin-bottom: 15px;
        .chat-popup-item {
          .chat-popup-item-box {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 0.94rem;
            height: 0.97rem;
            margin-left: 0.14rem;
            margin-top: 0.14rem;
            border: 0.01rem solid #dbdbdb;
            border-radius: 0.05rem;
            cursor: pointer;
            .checkbox {
              position: absolute;
              top: -0.01rem;
              right: -0.01rem;
              width: 0.16rem;
              height: 0.16rem;
              border: 0.01rem solid #dbdbdb;
              text-align: center;
              border-radius: 0rem 0.05rem;
              background: #dbdbdb url(./img/yes.png) no-repeat center center;
              z-index: 100;
            }
            .checkboxSel {
              border: 0.01rem solid #02a8a2;
              background: #02a8a2 url(./img/yes.png) no-repeat center center;
            }
            .chat-popup-item-content {
              text-align: center;
              .yesimg {
                width: 0.4rem;
                height: 0.4rem;
              }
              .text1 {
                margin-top: 0.04rem;
                font-size: 0.12rem;
                color: #333;
              }
              .text2 {
                margin-top: 0.04rem;
                font-size: 0.1rem;
                color: #999;
              }
            }
          }
        }
        .popupSel {
          border: 0.01rem solid #02a8a2 !important;
        }
      }
      img {
        height: 0.25rem;
      }
      .plug-item-color {
        width: 0.25rem;
        height: 0.25rem;
        margin-right: 0.1rem;
        cursor: pointer;
      }
      .plug-item-color-active {
        cursor: not-allowed;
        opacity: 0.4;
        // border: .01rem solid #02a8a2;
      }

      .plug-submit {
        position: absolute;
        right: 0.15rem;
        bottom: 0rem;
        width: 0.45rem;
        height: 0.24rem;
        background-color: #02a8a2;
        color: #fff;
        border-radius: 0.03rem;
        line-height: 0.24rem;
        text-align: center;
        font-size: 0.12rem;
        cursor: pointer;
      }
      // .el-checkbox-group {
      //   display: flex;
      //   align-items: flex-start;
      // }
      // .el-checkbox {
      //   margin-right: .15rem;
      //   display: flex;
      //   align-items: center;
      // }
    }
  }
  .chat-shield {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0.12rem 0.16rem;
    position: absolute;
    // width: 123px;
    height: 0.89rem;
    top: -0.94rem;
    left: 0.6rem;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    box-shadow: 0px 2px 2px rgba(214, 214, 214, 0.25);
    border-radius: 0.06rem;
    .shield-item {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 0.14rem;
      color: #666666;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
        margin-right: 0.08rem;
      }
      .select_box {
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 50%;
        border: 1px solid #666666;
        margin-right: 0.08rem;
        text-align: center;
        &.active {
          border: 1px solid rgb(207, 45, 84);
          background-color: rgb(207, 45, 84);
          padding-left: 0.02rem;
          img {
            width: 0.1rem;
            height: 0.1rem;
          }
        }
      }
    }
    .shield-item-active {
      color: rgb(207, 45, 84);
    }
    .shield-bar {
      width: 100%;
      height: 0.01rem;
      background-color: #f4f4f4;
      margin: 0.12rem auto;
    }
  }

  .color-text-popup {
    width: 100%;
    height: 0.4rem;
    background-color: #fff;
    position: absolute;
    top: -0.4rem;
    left: 0;
    box-shadow: 0px -4px 8px rgba(238, 238, 238, 0.5);
    display: flex;
    align-items: center;
    .bar-bottom {
      width: 3.16rem;
      height: 0.01rem;
      background-color: #f5f5f5;
      position: absolute;
      bottom: 0;
      left: 0.12rem;
    }
    .color-text {
      padding-left: 0.12rem;
      img {
        width: 0.42rem;
        height: 0.2rem;
        margin-right: 0.08rem;
        cursor: pointer;
      }
      .not-click {
        cursor: not-allowed;
      }
      .lv_item {
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        padding: 0 0.1rem;
        display: inline-block;
        position: relative;
        margin-right: 0.1rem;
        border-radius: 0.1rem;
        color: #fff;
        cursor: pointer;
        img {
          position: absolute;
          right: -0.03rem;
          bottom: -0.03rem;
          width: 0.06rem;
        }
      }
    }
  }
  .colorfull-arrow {
    width: 0.24rem;
    height: 0.24rem;
    position: absolute;
    top: -0.14rem;
    right: 0.38rem;
  }
  .colorfull-popup {
    width: 1.3rem;
    height: 1.56rem;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(19, 99, 96, 0.15);
    border-radius: 5px;
    position: absolute;
    top: -1.7rem;
    right: 0.12rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0.12rem 0;
    .colorfull-popup-list {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 0.24rem;
        height: 0.4rem;
      }
      .mid {
        display: flex;
        align-items: center;
        // justify-content: center;
        width: 0.76rem;
        height: 0.4rem;
        background: url("./img/colorful1-mid.png");
        background-size: 100% 100%;
        color: #ffffff;
        font-size: 0.12rem;
      }
      .mid2 {
        background: url("./img/colorful2-mid.png");
        background-size: 100% 100%;
      }
      .mid3 {
        background: url("./img/colorful3-mid.png");
        background-size: 100% 100%;
      }
    }
  }

  .icon_btn {
    display: flex;
    align-items: center;
    height: 0.4rem;
  }

  .icon-img {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.1rem;
    cursor: pointer;
  }
  .colorfull {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .icon-bar {
      width: 0.01rem;
      height: 0.18rem;
      background: #eeeeee;
      margin-right: 0.16rem;
    }
    img {
      width: 0.7rem;
      height: 0.19rem;
      cursor: pointer;
    }
  }

  .sent_content {
    width: 100%;
    display: flex;

    .input_content {
      flex: 1;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      border-radius: 4px 0 0 4px;
      height: 0.48rem;
      font-size: 0.12rem;
      display: flex;
      justify-content: space-between;
      .not_login {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .l_text1 {
          color: #26d99d;
          cursor: pointer;
        }
        .l_text2 {
          color: #999999;
        }
      }
      .login_input {
        /* width: 100%; */
        padding: 0.12rem 0.16rem;
        border: none;
        outline: none;
        height: 100%;
      }
      .write-color {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 0.24rem;
          height: 0.24rem;
          margin-left: 0.12rem;
          margin-right: 0.12rem;
        }
        .bar {
          width: 0.01rem;
          height: 0.4rem;
          background: linear-gradient(
            rgba(229, 229, 229, 0),
            rgba(229, 229, 229, 1),
            rgba(229, 229, 229, 0)
          );
        }
        .colorful-text {
          width: 0.6rem;
          height: 0.16rem;
        }
      }
    }
    .input_send {
      background: rgba(207, 45, 84, 1);
      border-radius: 0px 4px 4px 0px;
      color: #fff;
      /* width: 0.6rem; */
      height: 0.48rem;
      font-size: 0.14rem;
      text-align: center;
      line-height: 0.48rem;
      cursor: pointer;
      padding: 0 0.1rem;
    }
  }
}
.out {
  padding: 0.03rem 0.06rem;
  border-radius: 1rem;
  background: linear-gradient(90deg, #ffd9e2 0%, #ff7e9d 100%);
  .text_box {
    background-clip: text;
    background: linear-gradient(
      88.79deg,
      #f910f0 -0.5%,
      #ff7512 43.67%,
      #942aff 70.12%,
      #ff0c0c 98.97%
    );
    font-weight: 700;
    font-size: 0.14rem;
    color: #ffffff;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
::v-deep {
  .el-form {
    margin: 0 auto;
  }
  .block-user-step1 {
    padding-bottom: 0.24rem;
    .el-form-item__label-wrap {
      float: none !important;
      margin-left: 0 !important;
    }
    .el-form-item__content {
      padding-left: 0.25rem !important;
      padding-right: 0.25rem !important;
      margin-left: 0 !important;
      .el-select {
        width: 100% !important;
        input {
          width: 100% !important;
        }
      }
    }
  }
}
</style>
